import { render, staticRenderFns } from "./HdjlEdit.vue?vue&type=template&id=2fb76668&scoped=true"
import script from "./HdjlEdit.vue?vue&type=script&lang=js"
export * from "./HdjlEdit.vue?vue&type=script&lang=js"
import style0 from "./HdjlEdit.vue?vue&type=style&index=0&id=2fb76668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb76668",
  null
  
)

export default component.exports